// Translations
import ru from './ruRU.json';
import en from './enUS.json';

export const locales = {
  ru,
  en
};
